import { Trans, useTranslation } from "react-i18next";
import AppBar from "@/react/Webshop/Mobile/Components/AppBar";
import MobilePage, { PageHeader } from "@/react/Webshop/Components/MobilePage";
import React from "react";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { usePortal } from "../../../../Providers/PortalProvider";
import { useAuth } from "../../../providers/AuthProvider";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@/react/components/Common/Button";
import Box from "@mui/material/Box";
const useStyles = makeStyles({
    root: {},
});
export default () => {
    const classes = useStyles();
    const portal = usePortal();
    const { t } = useTranslation();
    const { user, patchUser } = useAuth();
    console.log("The user is", user);
    return (React.createElement(MobilePage, { requireUser: true },
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Download my data")),
        React.createElement(Container, { className: classes.root, maxWidth: "sm" },
            React.createElement(Card, null,
                React.createElement(CardContent, null,
                    React.createElement("p", null,
                        React.createElement(Trans, null, "You can download a copy of all data connected to your user at any time by clicking 'Download my data'.")),
                    React.createElement("p", null,
                        React.createElement(Trans, null, "A zip-file will be downloaded to your device, and you will have to unzip it to view the content.")),
                    React.createElement("p", null,
                        React.createElement(Trans, null, "We recommend using a computer as phones and tablets may not be able to open the zip file or show the information correctly.")),
                    React.createElement(Box, { display: "flex", justifyContent: "center" },
                        React.createElement(Button, { href: "/sections/prophoto/ajax/download_account_info.php" },
                            React.createElement(Trans, null, "Download my data"))))))));
};
